<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header>
    <card>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col>
                    <div class="card-wrapper">
                        <card>
                            <h2 class="mb-0">STATUS TUKAR LANTIK PP01/2016</h2>
                            <br />
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NAMA</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5">{{NamaPeribadi}}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NO KAD PENGENALAN</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5" class="col text-left">{{NoKP}}</b-col>
                                <!-- <b-button variant="default">Carian Pengguna</b-button> -->
                            </b-row>
                        </card>
                    </div>
                </b-col>
            </b-row>
            <br />
            <div >
                <validation-observer v-slot="{ invalid }">
                    <card header-classes="bg-transparent">
                        <h3 class="mb-0">STATUS TUKAR LANTIK PP01/2016</h3>
                        <br />
                        <div class="pl-lg-4">
                            <validation-provider name="Tarikh Dijangka Bersara" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3"> Tarikh Kuatkuasa Gaji KUP * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">

                                        <base-input type="date" v-model="ObjTukarLantik.DtTukarLantik" size="sm"></base-input>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <b-row>
                                <b-col sm="1"></b-col>
                            </b-row>
                            <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                                <b-row>
                                    <b-col sm="3"> Klasifikasi Perkhidmatan Tukar Lantik * </b-col>
                                    <b-col sm="1"> :</b-col>
                                    <b-col sm="8">
                                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjTukarLantik.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 50%" aria-describedby="input-2-live-feedback">
                                            <template #first>
                                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <br />
                            <b-row>
                                <b-col sm="1"></b-col>
                            </b-row>
                            <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                                <b-row>
                                    <b-col sm="3"> Skim Tukar Lantik *</b-col>
                                    <b-col sm="1"> :</b-col>
                                    <b-col sm="8">
                                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjTukarLantik.SchmOfServId" :options="SchmOfServList" @change="runMethod2()" style="width: 60%" aria-describedby="input-2-live-feedback">
                                            <template #first>
                                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <br />
                            <b-row class="my-1">
                            </b-row>
                            <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3"> Gred Tukar Lantik * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">
                                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjTukarLantik.SalGrdID" :options="SalGrdList" style="width: 60%" aria-describedby="input-2-live-feedback">
                                            <template #first>
                                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <br />
                            <validation-provider name="SalGrdPertama" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3">Amaun Gaji Tukar Lantik * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="ObjTukarLantik.SalTukarLantik" :state="getValidation(validationContext)"></b-form-input>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            
                            <b-col>&nbsp;</b-col>
                            <b-form-row>
                                <b-col>
                                    <b-form-group>
                                        <div>
                                            <b-col>&nbsp;</b-col>
                                            <b-col align="center">
                                                <b-button variant="success" type="submit" @click="simpan()" v-show="simpa2">SIMPAN</b-button>
                                                <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->

                                            </b-col>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </div>
                    </card>
                </validation-observer>
            </div>
            <!-- <div >
                <card header-classes="bg-transparent">
                    <b-button size="md" variant="primary" @click="next()">SETERUSNYA</b-button>
                    <br />
                </card>
            </div> -->
        </b-container>
    </card>
</div>
</template>

<script>
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
export default {
    data() {
        return {
            form: {
                NoKP: "830512065661"
            },
            options: [{
                    text: 'YA',
                    value: '1'
                },
                {
                    text: 'TIDAK',
                    value: '0'
                }
            ],
            ServClassId: null,
            SchmOfServId: null,
            selectedSalGrd: null,
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            StatusTukarLantik: 1,
            ObjTukarLantik: {},
            active: false,
            simpa2: true,
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        runMethod() {
            

            let Search = {
                ServClassId: this.ObjTukarLantik.ServClassId,
            };
            console.log(Search);
            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            

            let Search = {
               ServClassId: this.ObjTukarLantik.ServClassId,
                SchmOfServId: this.ObjTukarLantik.SchmOfServId,
            };
            console.log(this.ServClassId);
            GetselenggaraService.getSenaraiSalGrd(Search)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        simpan() {
            //console.log("objek sebelum simpan",this.ObjTukarLantik);
            this.$store.commit("clearMaklTukarLantik")
            this.ObjTukarLantik.StatusTukarLantik=this.StatusTukarLantik;
            this.$store.commit("addMaklTukarLantik", this.ObjTukarLantik);
            //console.log("state tukar lantik",this.$store.state)
            this.simpa2 = false;
            this.active = true;
            //console.log("objek ini",this.ObjTukarLantik);

            this.$router.push({
                name: 'MAKLUMAT KIRA GAJI',
            })

        },

        next() {
            //console.log(this.NoKP)
            this.$router.push({
                name: 'MAKLUMAT KIRA GAJI',
            })
        }
    },

    computed: {
        MaklumatPeribadiInStore() {
            return Store.state.MaklumatPeribadi;

        },

        returnTukarLantikInStore(){
            return Store.state.MaklTukarLantik;
            //console.log("ini paparMaklPegGaji",Store.state.paparMaklPegGaji);
        }

    },

    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        this.NamaPeribadi = this.$store.state.MaklumatPeribadi.Nama;
        this.NoKP = this.$store.state.MaklumatPeribadi.NoKP;

        this.ObjTukarLantik = this.$store.state.MaklTukarLantik;

                GetselenggaraService.getSenaraiSchmOfServ()
            .then((resp) => {
                this.SchmOfServList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSalGrd()
            .then((resp) => {
                this.SalGrdList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

    }
}
</script>

<style>
h2 {
    text-decoration: underline;
}

.numbers {
    text-decoration: underline;
    text-decoration-color: white;
}
</style>
